import type { VariantLoadingSizeProps } from '../const';
import { cn } from '@utils';
import { forwardRef } from 'react';
import { generateArray, getAnimationDelay, getSizeClass, SR_LOADING_TEXT } from '../helper';
import '../index.less';

function BarsLoading({ className, size = 'md' }: VariantLoadingSizeProps, ref: React.Ref<HTMLDivElement>) {
  const barCount = 3;

  return (
    <div ref={ref} className={cn('wg-variant-loading__bars-container', getSizeClass(size), className)}>
      {generateArray(barCount).map(i => (
        <div
          key={i}
          className={cn('wg-variant-loading__bar', getSizeClass(size))}
          style={{ animationDelay: `${getAnimationDelay(i, 'bars')}ms` }}
        />
      ))}
      <span className="wg-variant-loading__sr-only">{SR_LOADING_TEXT}</span>
    </div>
  );
}

const BarsLoadingComponent = forwardRef<HTMLDivElement, VariantLoadingSizeProps>(BarsLoading);
BarsLoadingComponent.displayName = 'BarsLoading';

export default BarsLoadingComponent;
